import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomPrintImagesStateType {
    hideImagesOnPrint: boolean;
    isLoading?: boolean;
}

export type CustomPrintImagesState = Readonly<CustomPrintImagesStateType>;

const initialCounterState: CustomPrintImagesState = {
    hideImagesOnPrint: false,
    isLoading: false,
};

export const customReducerPrintImages = createTypedReducer(initialCounterState, {
    "Custom/PrintImagesState/Loading": (
        draft: Draft<CustomPrintImagesState>,
        { isLoading }: { isLoading: boolean },
    ) => ({
        ...draft,
        isLoading,
    }),

    "Custom/PrintImagesState/SetPrintImagesPreference": (
        draft: Draft<CustomPrintImagesState>,
        { hideImagesOnPrint }: { hideImagesOnPrint: boolean },
    ) => ({
        ...draft,
        hideImagesOnPrint,
    }),

    "Custom/PrintImagesState/FailedToLoad": (
        draft: Draft<CustomPrintImagesState>,
        { message }: { message: string },
    ) => ({
        ...draft,
        isLoading: false,
        errorMessage: message,
    }),
});
